import React, {useCallback, useEffect, useState} from "react";
import useStyles from "isomorphic-style-loader/useStyles";
import classes from "./style.module.scss";
import ReactDOM from "react-dom";
import {Iconfont} from "../../../components/icon/iconfont";
import {ContainerMask} from "../../../components/mask";
import {FormattedMessage} from "react-intl";
import {fetchGetMessage} from "../../../../api";

const TerminationAlert = props => {
    useStyles(classes);
    const {handleClose,couponData,setVerifyPopoverShow} = props;
    return <>
        <div className={classes.MainContainer}>
            <Iconfont onClick={handleClose} className={classes.CloseModal}>&#xe69a;</Iconfont>
            <div className={classes.CouponContainer}>
                <div className={classes.Coupon}>
                    <div className={classes.CouponName}>
                        <span>{couponData.couponName1}</span>
                    </div>
                </div>
                <div className={classes.Coupon2}>
                    <div className={classes.CouponName2}>
                        <span>{couponData.couponName2}</span>
                    </div>
                </div>
                <div className={classes.CouponCountMsg}>
                    <span>{couponData.couponCountMsg}</span>
                </div>
            </div>
            <div className={classes.Msg}>
                <span><FormattedMessage id="you_are_now_eligible_for_coupons" defaultMessage="You are now eligible for coupons!" /></span>
            </div>
            <div className={classes.Button1} onClick={handleClose}>
                <span><FormattedMessage id="continue_login" defaultMessage="Continue login" /></span>
            </div>
            <div className={classes.Return} onClick={()=>setVerifyPopoverShow(false)}>
                <span><FormattedMessage id="return" defaultMessage="Return" /></span>
            </div>
        </div>
    </>
}
export default props => {
    useStyles(classes);
    const {show, setShow,setVerifyPopoverShow} = props;
    const [couponData,setCouponData]=useState(null)
    console.log("@RegisterTerminationAlert",show)
    useEffect(async ()=>{
        const response=await fetchGetMessage('M0204')
        console.log("@response",response)
        if(response?.result?.message){
            setCouponData(JSON.parse(response?.result?.message))
        }
    },[])
    const handleClose = () => {
        setShow(false)
    }
    return <React.Fragment>
        {
            couponData&&show && ReactDOM.createPortal(<React.Fragment>
                <ContainerMask onClick={handleClose} style={{backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 20}}>
                    <TerminationAlert onClose={handleClose} couponData={couponData} setVerifyPopoverShow={setVerifyPopoverShow}/>
                </ContainerMask>
            </React.Fragment>, typeof document !== 'undefined' ? document.getElementById('root') : null)
        }
    </React.Fragment>
}